import { createSlice } from '@reduxjs/toolkit';

import { DASHBOARD_ACTIVE_CHART } from '../../core/constants';
import { getAllTimeRange, NO_COMPARISON_RANGE } from '../../core/utils';

import {
  setError,
  setSuccess,
  getDonationsData,
  setActiveChart,
  setCampaignId,
  setDateRange,
  setComparisonDateRange,
} from './actions';

// Default date range = 'All Time'. The account is not loaded when the store is
// created, so this starts at the fallback floor; DateRangePicker re-anchors it to
// the tenant's onboarding date as soon as the account lands.
const { startDate, endDate } = getAllTimeRange(null);

const initialState = {
  loading: false,
  error: false,
  success: false,
  donationsData: [],
  activeChart: DASHBOARD_ACTIVE_CHART.donations_usd,
  campaignId: '',
  startDate,
  endDate,
  // 'All Time' is not compared against anything — see NO_COMPARISON_RANGE.
  ...NO_COMPARISON_RANGE,
};

const dashboardStore = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setError, (state, { payload }) => {
      state.error = payload;
    });

    builder.addCase(setSuccess, (state, { payload }) => {
      state.success = payload;
    });

    builder.addCase(setActiveChart, (state, { payload }) => {
      state.activeChart = payload;
    });

    builder.addCase(setCampaignId, (state, { payload }) => {
      state.campaignId = payload;
    });

    builder.addCase(setDateRange, (state, { payload: { startDate, endDate } }) => {
      state.startDate = startDate;
      state.endDate = endDate;
    });

    builder.addCase(setComparisonDateRange, (state, { payload: { comparisonStartDate, comparisonEndDate } }) => {
      state.comparisonStartDate = comparisonStartDate;
      state.comparisonEndDate = comparisonEndDate;
    });

    builder.addCase(getDonationsData.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.donationsData = payload;
    });

    builder.addCase(getDonationsData.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });

    builder.addCase(getDonationsData.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message || true;
    });
  },
});

export default dashboardStore.reducer;
